import { call, put, takeEvery } from 'redux-saga/effects'
import * as mangXaHoiActions from '@redux/ducks/mangXaHoi.Ducks'
import * as baiVietApi from '@apis/mangXaHoi/baiViet.Api'
import * as binhLuanApi from '@apis/mangXaHoi/binhLuan.Api'
import * as camXucApi from '@apis/mangXaHoi/camXuc.Api'
import * as taiLieuApi from '@apis/mangXaHoi/taiLieu.Api'

function* fetchDanhSachBaiViet({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof baiVietApi.locBaiViet> = yield call(baiVietApi.locBaiViet, params)
    yield put(mangXaHoiActions.layDanhSachBaiVietThanhCong(res))
  } catch (error) {
    yield put(mangXaHoiActions.layDanhSachBaiVietThatBai(error))
  }
}

function* fetchChiTietBaiViet({ payload: id }: { type: string; payload: any }) {
  try {
    const res: ReturnType<typeof baiVietApi.layChiTietBaiViet> = yield call(baiVietApi.layChiTietBaiViet, id)
    yield put(mangXaHoiActions.layChiTietBaiVietThanhCong(res))
  } catch (error) {
    yield put(mangXaHoiActions.layChiTietBaiVietThatBai(error))
  }
}

function* fetchDanhSachBinhLuan({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof binhLuanApi.layBinhLuanBaiViet> = yield call(binhLuanApi.layBinhLuanBaiViet, params.postId || 0, params)
    yield put(mangXaHoiActions.layDanhSachBinhLuanThanhCong(res))
  } catch (error) {
    yield put(mangXaHoiActions.layDanhSachBinhLuanThatBai(error))
  }
}

function* fetchDanhSachCamXuc({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof camXucApi.layCamXucBaiViet> = yield call(camXucApi.layCamXucBaiViet, params.postId || 0)
    yield put(mangXaHoiActions.layDanhSachCamXucThanhCong(res))
  } catch (error) {
    yield put(mangXaHoiActions.layDanhSachCamXucThatBai(error))
  }
}

function* fetchDanhSachTaiLieu({ payload: queryStr }: { type: string; payload: any }) {
  try {
    const params = queryStr ? JSON.parse(queryStr) : {}
    const res: ReturnType<typeof taiLieuApi.layTaiLieuBaiViet> = yield call(taiLieuApi.layTaiLieuBaiViet, params.postId || 0)
    yield put(mangXaHoiActions.layDanhSachTaiLieuThanhCong(res))
  } catch (error) {
    yield put(mangXaHoiActions.layDanhSachTaiLieuThatBai(error))
  }
}

function* fetchDanhSachBaoCao({ payload: queryStr }: { type: string; payload: any }): Generator<any, void, any> {
  try {
    void queryStr
    const res: any = yield call(() => Promise.resolve({ data: [] }))
    yield put(mangXaHoiActions.layDanhSachBaoCaoThanhCong(res))
  } catch (error) {
    yield put(mangXaHoiActions.layDanhSachBaoCaoThatBai(error))
  }
}

export default function* watchMangXaHoi() {
  yield takeEvery(mangXaHoiActions.layDanhSachBaiViet.toString(), fetchDanhSachBaiViet)
  yield takeEvery(mangXaHoiActions.layChiTietBaiViet.toString(), fetchChiTietBaiViet)
  yield takeEvery(mangXaHoiActions.layDanhSachBinhLuan.toString(), fetchDanhSachBinhLuan)
  yield takeEvery(mangXaHoiActions.layDanhSachCamXuc.toString(), fetchDanhSachCamXuc)
  yield takeEvery(mangXaHoiActions.layDanhSachTaiLieu.toString(), fetchDanhSachTaiLieu)
  yield takeEvery(mangXaHoiActions.layDanhSachBaoCao.toString(), fetchDanhSachBaoCao)
}
